module.exports = __webpack_public_path__ + "img/10软件开发.696a076e.png";